import React from "react";
import { NavLink } from "react-router-dom";

const ProbateValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
        Probate Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Probate property valuation are required in decease estate matters
          where the landlord had passed away and have given the execution to the
          beneficiary to engaged a license property valuer to determine the fair
          market value. Primus Agent Services have over ten (10) years
          experience in providing probate valuations.
        </p>
      </div>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default ProbateValuationTab;
